import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ImportDataContainer, type ImportDataContainerProps,
} from './importData.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ImportData: ImportDataContainerProps;
  }
}
modalRenderer.register('ImportData', ImportDataContainer);
